module.exports = __webpack_public_path__ + "media/src/images/balloons/green_gradient-c6783b23ac8c12ef0260424cfaf043c4.jpg";